import { render, staticRenderFns } from "./DialogSuccess.vue?vue&type=template&id=056771fc&scoped=true&"
import script from "./DialogSuccess.vue?vue&type=script&lang=js&"
export * from "./DialogSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DialogSuccess.vue?vue&type=style&index=0&id=056771fc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056771fc",
  null
  
)

export default component.exports